import { render, staticRenderFns } from "./SubmitCostModal.vue?vue&type=template&id=3b039705&scoped=true&"
import script from "./SubmitCostModal.vue?vue&type=script&lang=js&"
export * from "./SubmitCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b039705",
  null
  
)

export default component.exports